import { TrainingPeriod } from '../../shared/constants';

export type ITrainingPeriodOption = {
  id: TrainingPeriod;
  name: string;
};

function getPeriodMinimumAccessMonths(period: TrainingPeriod): number | null {
  switch (period) {
    case TrainingPeriod.week:
    case TrainingPeriod.month:
      return 1;
    case TrainingPeriod.threeMonth:
      return 3;
    case TrainingPeriod.sixMonth:
      return 6;
    case TrainingPeriod.oneYear:
      return 12;
    case TrainingPeriod.allTime:
      return null;
    default:
      return 1;
  }
}

export function filterTrainingPeriodOptionsByStatisticsAccess<
  T extends ITrainingPeriodOption,
>(options: T[], periodStatisticsAccess: number | null | undefined): T[] {
  const monthFallback = options.find((opt) => opt.id === TrainingPeriod.month);

  if (periodStatisticsAccess == null) {
    return options;
  }

  const filteredOptions = options.filter((opt) => {
    const requiredMonths = getPeriodMinimumAccessMonths(opt.id);
    if (requiredMonths === null) {
      return false;
    }
    return requiredMonths <= periodStatisticsAccess;
  });

  return filteredOptions.length > 0 ? filteredOptions : [];
}

export function getDefaultTrainingPeriodByStatisticsAccess<
  T extends ITrainingPeriodOption,
>(options: T[]): TrainingPeriod | null {
  if (options.length === 0) {
    return null;
  }

  const monthOption = options.find((opt) => opt.id === TrainingPeriod.month);
  if (monthOption) {
    return TrainingPeriod.month;
  }

  return options[0].id;
}
